/**
 * Lengths and areas as a person reads them, in either unit system.
 *
 * Lives beside the viewer rather than in either app because the number
 * printed next to a wall must be formatted the same everywhere the wall is
 * shown — the installer portal's workspace and the customer's read-only view
 * alike. Two `toFixed(2)`s in two apps is how "8.52 m²" and "8.5 m²" end up
 * describing the same wall.
 */

export type Units = "m" | "ft";

const FEET_PER_METRE = 3.280839895;

export function formatLength(metres: number, units: Units): string {
  if (units === "ft") return `${(metres * FEET_PER_METRE).toFixed(2)} ft`;
  return `${metres.toFixed(2)} m`;
}

export function formatArea(squareMetres: number, units: Units): string {
  if (units === "ft") {
    return `${(squareMetres * FEET_PER_METRE * FEET_PER_METRE).toFixed(2)} ft²`;
  }
  return `${squareMetres.toFixed(2)} m²`;
}
